import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward"
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward"
import ArrowDown from "@material-ui/icons/ExpandMore"
import React from "react"
import classnames from "classnames"
import { useDefaultSortAction } from "../../../actions/useDefaultSortAction"
import { useDisplayIcon } from "../../../actions/useDisplayIcon"
import styles from "./DefaultSort.module.scss"

const DefaultSort = ({ sort, sorts, setSort }) => {
  const {
    showItems,
    toggleItems,
    setShowItems,
    sortType,
    onChangeSortType,
    toShow,
    sanatize,
    _sorts,
  } = useDefaultSortAction(sort, sorts, setSort)
  const display = useDisplayIcon()

  return (
    <div className="mt-0 position-relative">
      <span className="color-gray-super-light fs-14px mr-2">Sort by</span>
      <span
        className={classnames(styles["sorting"], "mr-2", "position-relative")}
        onClick={() => toggleItems()}>
        {sanatize(toShow)}
        <ArrowDown
          style={{
            verticalAlign: "middle",
            fontSize: "15px",
            position: "absolute",
            top: "8px",
            right: "4px",
            display,
          }}
        />
      </span>
      {showItems &&
        _sorts
          .filter((_sort) => _sort.title !== sanatize(toShow))
          .map((_sort, index) => (
            <div
              className={classnames(
                styles["sorting"],
                styles["sorting-item"],
                "position-absolute",
              )}
              key={index}
              style={{ top: `${35 * (index + 1)}px` }}
              onClick={() => {
                setSort(`${_sort.title.toLowerCase()}${sortType}`)
                setShowItems(false)
              }}>
              {_sort.title}
            </div>
          ))}
      {sortType === "" && (
        <ArrowDownwardIcon
          onClick={() => {
            onChangeSortType()
          }}
          style={{ fontSize: "16px", display }}
        />
      )}
      {sortType === "desc" && (
        <ArrowUpwardIcon
          onClick={() => {
            onChangeSortType()
          }}
          style={{ fontSize: "16px", display }}
        />
      )}
    </div>
  )
}

export default DefaultSort
